if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            const parent = activeMedia.parentElement;
            const originalScrollBehavior = parent.style.scrollBehavior;
            parent.style.scrollBehavior = 'auto'; // Bypass CSS smooth scrolling temporarily
            parent.scrollTo({ left: activeMedia.offsetLeft });
            parent.getBoundingClientRect(); // Force layout engine recalculation
            parent.style.scrollBehavior = originalScrollBehavior; // Restore original scroll behavior
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            //activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        const slider = this.elements.thumbnails.slider;
        const originalScrollBehavior = slider.style.scrollBehavior;
        slider.style.scrollBehavior = 'auto'; // Bypass CSS smooth scrolling temporarily
        slider.scrollTo({ left: thumbnail.offsetLeft });
        slider.getBoundingClientRect(); // Force layout engine recalculation
        slider.style.scrollBehavior = originalScrollBehavior; // Restore original scroll behavior
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
      //  window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* ---------------------------------------------------------------------------
   ANYWAY — Mobile PDP gallery pagination (dots + arrows, one image per tap)
   Builds one dot per visible slide, keeps the active dot in sync with the
   swipe position, and lets the arrows/dots move exactly one image at a time.
   Purely additive: desktop keeps its thumbnail strip (pagination is hidden
   above 750px via CSS).
   --------------------------------------------------------------------------- */
(function () {
  function initGalleryPagination(gallery) {
    const pagination = gallery.querySelector('[data-pdp-pagination]');
    if (!pagination) return;
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]') || gallery;
    const slider = viewer.querySelector('[id^="Slider-Gallery"]');
    if (!slider) return;

    const dotsWrap = pagination.querySelector('[data-pdp-dots]');
    const prevButton = pagination.querySelector('[data-pdp-prev]');
    const nextButton = pagination.querySelector('[data-pdp-next]');

    const visibleSlides = () =>
      Array.from(slider.querySelectorAll('.product__media-item')).filter((s) => s.clientWidth > 0);

    let dots = [];

    function buildDots() {
      const slides = visibleSlides();
      if (slides.length < 2) {
        pagination.style.display = 'none';
        dotsWrap.innerHTML = '';
        dots = [];
        return;
      }
      pagination.style.removeProperty('display');
      if (dots.length === slides.length) return; // already built for this count
      dotsWrap.innerHTML = '';
      dots = slides.map((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-mp__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('data-pdp-dot', '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', () => scrollToIndex(i));
        dotsWrap.appendChild(dot);
        return dot;
      });
    }

    function currentIndex() {
      const slides = visibleSlides();
      if (!slides.length) return 0;
      const sliderLeft = slider.getBoundingClientRect().left;
      let idx = 0;
      let min = Infinity;
      slides.forEach((slide, i) => {
        const d = Math.abs(slide.getBoundingClientRect().left - sliderLeft);
        if (d < min) {
          min = d;
          idx = i;
        }
      });
      return idx;
    }

    function scrollToIndex(i) {
      const slides = visibleSlides();
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      const delta = slides[i].getBoundingClientRect().left - slider.getBoundingClientRect().left;
      slider.scrollBy({ left: delta, behavior: 'smooth' });
    }

    function sync() {
      if (!dots.length) return;
      const idx = currentIndex();
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
    }

    let rafId;
    slider.addEventListener('scroll', () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(sync);
    });
    if (prevButton) prevButton.addEventListener('click', () => scrollToIndex(currentIndex() - 1));
    if (nextButton) nextButton.addEventListener('click', () => scrollToIndex(currentIndex() + 1));

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        buildDots();
        sync();
      }, 200);
    });

    buildDots();
    sync();
  }

  const start = () => document.querySelectorAll('media-gallery').forEach(initGalleryPagination);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------------------
   ANYWAY — Desktop PDP main-image navigation
   Elegant arrows beside the image + physical arrow-key support. Reuses the
   gallery's own setActiveMedia(), so the thumbnail rail stays in sync and the
   swap gets the CSS fade. Desktop only.
   --------------------------------------------------------------------------- */
(function () {
  // Move the active image by `dir` (+1 / -1) using the visible thumbnail order.
  // Returns true if it actually navigated.
  function galleryNavStep(gallery, dir) {
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return false;
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbs) return false;
    const items = Array.from(thumbs.querySelectorAll('[data-target]')).filter(
      (el) => el.offsetParent !== null
    );
    if (items.length < 2) return false;
    let index = items.findIndex((el) => {
      const button = el.querySelector('button');
      return button && button.getAttribute('aria-current') === 'true';
    });
    if (index < 0) index = 0;
    index = (index + dir + items.length) % items.length;
    gallery.setActiveMedia(items[index].dataset.target, false);
    return true;
  }

  function wireSideArrows(gallery) {
    const prev = gallery.querySelector('[data-pdp-side-prev]');
    const next = gallery.querySelector('[data-pdp-side-next]');
    if (prev) prev.addEventListener('click', () => galleryNavStep(gallery, -1));
    if (next) next.addEventListener('click', () => galleryNavStep(gallery, 1));
  }

  const desktopMql = window.matchMedia('(min-width: 750px)');

  function onKeydown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (!desktopMql.matches) return;

    // Ignore while typing or when a control is focused
    const target = event.target;
    if (
      target &&
      (target.isContentEditable ||
        (target.matches && target.matches('input, textarea, select, [contenteditable="true"]')))
    ) {
      return;
    }
    // The lightbox handles its own arrow keys
    if (document.querySelector('product-modal[open]')) return;

    const gallery =
      document.querySelector('media-gallery:not([id*="duplicate"])') ||
      document.querySelector('media-gallery');
    if (!gallery) return;

    if (galleryNavStep(gallery, event.key === 'ArrowRight' ? 1 : -1)) {
      event.preventDefault();
    }
  }

  const start = () => {
    document.querySelectorAll('media-gallery').forEach(wireSideArrows);
    document.addEventListener('keydown', onKeydown);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
